














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { TicketSettingModule } from '@/store/modules/ticketsetting';
import { TicketSetting, IPlanSummaryData, BookingTypeEnum } from '@/api/types';
import {
  PlanAndUnitWithBookingType,
  planAndUnitWithBookingTypeToText,
} from '@/utils/tickets';

type HeaderType = {
  text: string;
  value: string;
};

type WithProductName = {
  productName: string;
};

@Component({
  name: 'TicketSettingListResult',
})
export default class extends Vue {
  @Prop({ required: true }) plans!: IPlanSummaryData[];
  @Prop({ required: true }) tickets!: TicketSetting[];
  private items: (TicketSetting & WithProductName)[] = [];
  private headers: HeaderType[] = [];
  private loading = true;
  private filterText = '';

  mounted() {
    this.loadItems();
    this.loadHeaders();
    this.loading = false;
  }

  loadItems() {
    this.items = JSON.parse(JSON.stringify(this.tickets));
    const planAndUnitItemsByPlanIdAndUnitId: Map<
      string,
      Map<string, PlanAndUnitWithBookingType>
    > = new Map();
    this.plans.forEach(p => {
      if (!planAndUnitItemsByPlanIdAndUnitId.has(p.planId)) {
        planAndUnitItemsByPlanIdAndUnitId.set(p.planId, new Map());
      }
      p.units.forEach(u => {
        planAndUnitItemsByPlanIdAndUnitId.get(p.planId)!.set(u.id, {
          activityId: p.activityId,
          activityTitle: p.activityTitle,
          planId: p.planId,
          planTitle: p.planTitle,
          unitId: u.id,
          unitTitle: u.title,
          bookingType: p.bookingType || BookingTypeEnum.EACH_TIME,
        });
      });
    });
    this.items.forEach(i => {
      i.productName =
        planAndUnitItemsByPlanIdAndUnitId.has(i.planId) &&
        planAndUnitItemsByPlanIdAndUnitId.get(i.planId)!.has(i.unitId)
          ? planAndUnitWithBookingTypeToText(
              this.$i18n,
              planAndUnitItemsByPlanIdAndUnitId.get(i.planId)!.get(i.unitId)!
            )
          : '';
    });
  }

  private loadHeaders() {
    // const id: HeaderType = {
    //   text: this.$t('Id') as string,
    //   value: 'id',
    // };
    const productName: HeaderType = {
      text: this.$t('Activity name') as string,
      value: 'productName',
    };
    const title: HeaderType = {
      text: this.$t('{msg} name', { msg: this.$t('Ticket setting') }) as string,
      value: 'title',
    };
    const isInactive: HeaderType = {
      text: `${this.$t('Active')}/${this.$t('Inactive')}`,
      value: 'isInactive',
    };
    const operations: HeaderType = {
      text: this.$t('Operations') as string,
      value: 'operations',
    };
    const headers: HeaderType[] = [productName, title, isInactive, operations];
    this.headers = headers;
  }

  private getIsInactiveText(isInactive: boolean) {
    return isInactive ? this.$t('Inactive') : this.$t('Active');
  }

  private navigateWithTicket(ticket: TicketSetting) {
    this.$router.push({
      name: 'ticketsetting-detail',
      params: {
        id: ticket.id!,
        // ticket: JSON.stringify(ticket),
      },
    });
  }
}
